import {Floor} from "./floor";
import {clearGroup} from "../../sceneManager";
import {buildingGroup, tmpGroup} from "../../main";
import {findChildByName, getPointsFromBoundingBox} from "../../utils/threeUtils";
import {Box3, Vector3} from "three";
import * as Globals from "../../globals";
import {setObjectLayer} from "../../utils/layerUtils";
import {floorTypes} from "./floorGeneration";
import {createExtendedWallSegment, createWallSegment, cutWallWithMesh} from "../walls/wall";
import {recalculateVolumes} from "../../utils/volumeUtils";
import {createMeshFromShape, createShapeFromPoints, getMeshWithHoleFromShape} from "../../utils/shapeUtils";
import {getMTEMeshFromThickness} from "../../utils/configuratorUtils";
import {RoofOrientation, RoofTypes} from "../../constants/roofConstants";
import {basePlateFloorMaterial} from "../../constants/materialConstants";
import {cutOutsGroupName, floorGroupName, roofGroupName} from "../../constants/nameConstants";
import {MteFloorConfigCalculator} from "../../calculators/floor/mtefloor/MteFloorConfigCalculator";

export const maxAllowedElementLength = 13.5; //Meter. Maximale Reallänge der Bodenelemente. Bei größeren Längen muss geschnitten / mehrere Elemente zusammengesetzt werden auf Wand oder Unterzug

export class MTEFloor extends Floor {
    constructor(floorIncludeOutside) {
        super(floorIncludeOutside);

        this.thickness = 0.2;
        this.floorShape = createShapeFromPoints(this.floorPoints);
        this.floorMesh = createMeshFromShape(this.floorShape, {
            depth: this.thickness + 0.5,
            bevelEnabled: false
        }, basePlateFloorMaterial);
        //Default roof orientation X Axis
        this.orientation = RoofOrientation.XAxis;


        this.setThicknessAndOrientation();

        this.mteMesh = getMTEMeshFromThickness(this.thickness);

        this.create();
    }

    setThicknessAndOrientation()
    {
        let mteFloorConfig = new MteFloorConfigCalculator();
        this.thickness = mteFloorConfig.thickness;
        this.orientation = mteFloorConfig.orientation;
    }

    create() {
        //Manuelle Dachorientierung
        let floor = this.createWithOrientation(this.orientation, true);
        buildingGroup.addWithUuid(floor); //Einfügen der Decke

        floor.userData.floor = {
            orientation: this.orientation,
            thickness: this.thickness,
            type: floorTypes.mteElement,
            includeOutside: this.includeOutside
        };

        clearGroup(tmpGroup);
        return floor;
    }

    createWithOrientation(orientation, withOverhang = false) {
        let previewBounds = new Box3().setFromObject(this.floorMesh);
        let floorValues = this.getFloorValues(orientation);
        let rotate = floorValues.rotate;
        let cutMesh = this.createCuttingMesh(rotate, withOverhang);

        let floor;
        if (floorValues.depth > maxAllowedElementLength) {
            //TODO: Calculate sections
            let neededElements = Math.ceil(floorValues.depth / maxAllowedElementLength); //Mindestanzahl an Elementen um Fläche decken zu können
            let singleWidth = floorValues.depth / neededElements; //Einzelne Elementlänge wenn Anzahl auf die Fläche geteilt wird
            let widths = [];
            for (let i = 0; i < neededElements; i++) {
                widths.push(singleWidth);
            }
            floor = createExtendedWallSegment(floorValues.width, widths, this.mteMesh, Globals.layers.floor, false);
        } else {
            floor = createWallSegment(floorValues.width, floorValues.depth, this.mteMesh, Globals.layers.floor, false);
        }

        floor.name = floorGroupName;

        this.cutFloorElementsToShape(floor, cutMesh);
        cutMesh.geometry.dispose();

        if (rotate) {
            floor.rotateY(Math.PI / 2);
        }
        let floorBounds = new Box3().setFromObject(floor);
        let moveVector = new Vector3().copy(previewBounds.min).sub(floorBounds.min).add(floor.position);
        floor.position.set(moveVector.x, -this.thickness, moveVector.z);
        return floor;
    }

    getFloorValues(orientation) {
        let previewBounds = new Box3().setFromObject(this.floorMesh);
        let previewSize = previewBounds.getSize(new Vector3());
        let depth, width;
        let rotate = false;

        if (orientation === RoofOrientation.XAxis) {
            rotate = true;
            width = previewSize.z;
            depth = previewSize.x;
        } else {
            width = previewSize.x;
            depth = previewSize.z;
        }

        return {
            width: width, //Kurze Seite
            depth: depth, //Lange Seite
            rotate: rotate
        };
    }

    createCuttingMesh(rotate) {
        let previewBounds = new Box3().setFromObject(this.floorMesh);
        let cutMeshBounds = new Box3().copy(previewBounds).expandByScalar(1.02);
        let points = getPointsFromBoundingBox(cutMeshBounds, true);
        let cutShape = createShapeFromPoints(points);
        return getMeshWithHoleFromShape(cutShape, this.floorPoints, rotate);
    }

    cutFloorElementsToShape(floor, cutMesh) {
        let floorElements = [];
        for (let i = 0; i < floor.children.length; i++) {
            if (floor.children[i].name === cutOutsGroupName) {
                continue;
            }
            floorElements.push(floor.children[i]);
        }

        cutWallWithMesh(floorElements, cutMesh, true, true, false);
        recalculateVolumes(floorElements);
        setObjectLayer(floor, Globals.layers.floor, true);
    }
}
